export function getCollectionRoute(collectionType: string) {
  if (collectionType === "noos") return "/demand-planning/noos/$collectionId" as const
  if (collectionType === "mixed" || collectionType === "fashion")
    return "/demand-planning/fashion/$collectionId" as const
  throw new Error(`Unknown collection type: ${collectionType}`)
}

/** A collection's demand plan: the Helix `/demand` module when it's shown, else `/demand-planning` */
export function getDemandPlanRoute(collectionType: string, showHelix: boolean) {
  if (!showHelix) return getCollectionRoute(collectionType)
  if (collectionType === "noos") return "/demand/noos/$collectionId" as const
  if (collectionType === "mixed" || collectionType === "fashion")
    return "/demand/fashion/$collectionId" as const
  throw new Error(`Unknown collection type: ${collectionType}`)
}

/** A collection's Demand tab: in Helix `/demand` when it's shown, else `/demand-planning`, which has none for NOOS */
export function getDemandTabRoute(collectionType: string, showHelix: boolean) {
  if (!showHelix) {
    return collectionType === "noos"
      ? null
      : ("/demand-planning/fashion/$collectionId/demand" as const)
  }
  return collectionType === "noos"
    ? ("/demand/noos/$collectionId/demand" as const)
    : ("/demand/fashion/$collectionId/demand" as const)
}

const MAX_INT4 = 2_147_483_647

/** Whether a `$collectionId` segment can name a collection: plain digits within Postgres int4. */
export function isCollectionIdParam(param: string): boolean {
  return /^[1-9]\d*$/.test(param) && Number(param) <= MAX_INT4
}
